const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_despacho-vt/artifacts/papa5vsc_vertice-logo.png";

export function Logo({ variant = "dark", size = "md" }) {
  // variant: "dark" for light backgrounds, "light" for dark backgrounds
  const isLight = variant === "light";
  const subColor = isLight ? "#C19B6C" : "#7A1E2E";
  const dim =
    size === "sm" ? { h: 32, textCls: "text-[10px]" } :
    size === "lg" ? { h: 64, textCls: "text-[11px]" } :
                    { h: 44, textCls: "text-[10px]" };

  return (
    <div className="flex items-center gap-3" data-testid="app-logo">
      <img
        src={LOGO_URL}
        alt="Vértice"
        style={{ height: dim.h, width: "auto" }}
        className={isLight ? "brightness-0 invert" : ""}
      />
      <div
        className={`${dim.textCls} uppercase tracking-[0.22em] font-semibold leading-tight max-w-[180px]`}
        style={{ color: subColor }}
      >
        Sistema de Despacho<br />Legal - Notarial
      </div>
    </div>
  );
}
